import { render, staticRenderFns } from "./UsersDisplay.vue?vue&type=template&id=0039a8ff"
import script from "./UsersDisplay.vue?vue&type=script&lang=js"
export * from "./UsersDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports